﻿(function () {
    'use strict';

    var controllerId = 'shell';

    angular
        .module('app.common')
        .controller(controllerId, ['$scope', '$interval', '$rootScope', 'common', 'config', function ($scope, $interval, $rootScope, common, config) {

            
            var vm = this;
            var events = config.events;
            // vm.busyMessage = 'Please wait ...';
            vm.busyMessage = '';
            vm.currentVersion = null;
            vm.isBusy = false;
            vm.showSplash = false;
            vm.spinnerOptions = config.spinnerOptions;
            vm.percent = '0%';
            vm.countbar = 0;

            function toogleSplash(show) {

                
                //vm.showSplash = show;
                vm.showSplash = false;
            }

            function progressSplash(percent) {
                
                //vm.percent = percent + '%';
                //common.activateController([])
                //    .then(function () {
                //        var count = $scope.vm.countbar;
                //        var interval = $interval(function () {

                //            if (count == 100) {
                //                $interval.cancel(interval);                                
                //            }else{                                
                //                count = count + 10;
                //                vm.percent = count +'%';
                //            }                            
                //        }, 100, 100);
                        
                //    });
            }

            
            $rootScope.$on(events.controllerToogleSplash, function (event, show) {
                
                if (show) {                    
                    vm.percent = '0%';
                }
                toogleSplash(show);
            });
            
            $rootScope.$on(events.controllerActivateSplashProgress, function (event, percent) {
                
                progressSplash(percent);
            });

            function toggleSpinner(on) {
                
                 vm.isBusy = on;
            };

            $rootScope.$on(events.controllerActivateInit, function () {
                
                //toggleSpinner(true);
                toggleSpinner(false);
            });

            $rootScope.$on(events.controllerActivateSuccess, function () {
                
                toggleSpinner(false);
            });

            $rootScope.$on(events.spinnerToggle, function (data) {
                
                //toggleSpinner(data.show);
                toggleSpinner(false);
            });


            
            return {
                progressSplash: null,
                toggleSpinner: null
            };

        }]);

})();